<template>
  <div
    v-show="loading"
    @click.prevent="toggleOverlay()"
    class="overlay"
  >
    <div
      v-show="hasOverlayMessage"
      class="overlay-message"
    >
      <div class="overlay-message-inner">
        {{ overlayMessage }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'showOverlay',
      'overlayMessage',
      'loading'
    ]),
    hasOverlayMessage: function () {
      return this.overlayMessage.length > 0
    }
  },
  methods: {
    ...mapActions([
      'setShowOverlay'
    ]),
    toggleOverlay: function () {
      // Don't remove overlay if loading
      if (!this.loading) {
        this.setShowOverlay(!this.showOverlay)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.overlay {
  background-color: rgba(242, 242, 242, .3);
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 10;

  .overlay-message {
    font-size: 1.5rem;
    left: 0;
    line-height: 200px;
    margin: auto;
    margin-top: -100px;
    position: absolute;
    text-align: center;
    top: 50%;
    width: 100%;

    .overlay-message-inner {
      background-color: #000000;
      border-radius: 10px;
      color: #ffffff;
      display: inline;
      padding: 20px 20px;
    }
  }
}
</style>
